import React from 'react'
import "./Footer.css"
function Footer() {
  return (
    <div className="footer notes-footer">
    <p className="footer-text">
        Made with &lt;Wind-UI/&gt;.
    </p>
</div>
  )
}

export default Footer